export default "__VITE_ASSET__Be1t6a1s__"